import { Component, OnInit, Input } from '@angular/core';

import { Breadcrumbs } from 'src/app/app.model';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnInit {
  @Input() title: string;
  @Input() description: string;
  @Input() urlConfig: Breadcrumbs[];

  constructor() {}

  ngOnInit(): void {}
}
